<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['view_loanarrears'] == 1 && userData.permissions['view_loans'] == 1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <span class="d-flex justify-content-between mb-2">
              <div class="d-flex justify-content-between">
                <div><label>From</label><input class="form-control" v-model="date_from" type="date"></div>
                <div class="mx-1"><label>To</label><input class="form-control" v-model="date_to" type="date"></div>
                <div class="mt-4"><b-button variant="primary" @click="FilterData"><i class="mdi mdi-filter"></i>
                    Filter</b-button></div>
              </div>
            </span>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm"
                      :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table :items="Items" :fields="Fields" responsive="sm" :per-page="perPage" :current-page="currentPage"
                :filter="filter" :filter-included-fields="filterOn" @filtered="Filtered" :busy="IsBusy">
                <template #table-busy>
                  <div class="text-center text-primary my-2"><b-spinner v-if="isBusy" class="align-middle" type="grow"
                      small></b-spinner> <i v-else class="fs-5 mdi mdi-cancel"></i> <strong>{{ isBusy ? 'Fetching Data...' : 'No Data Found' }}</strong></div>
                </template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(member)="data">
                  <router-link :to="{
                    path: '/memberprofile',
                    query: { id: data.item.member.member_id },
                  }">
                    <span @mouseover="name_hover = true; current_index = data.index" @mouseout="name_hover = false">
                      <span
                        :class="(name_hover && current_index == data.index) ? 'fw-bold text-dark text-decoration-underline' : 'text-dark'">{{
                          data.item.member.name }}</span>
                      <span class="d-block text-info fw-bold">{{ data.item.member.member_id }}</span>
                    </span>
                  </router-link>
                </template>
                <template #cell(loan_type)="data">
                  <b><span class="text-info">{{ data.item.loan_type.name }}</span> <br>
                    <small>{{ data.item.loan_type.rate }}%</small> &nbsp;&nbsp;&nbsp;
                    <small>{{ data.item.loan_type.period }}days</small></b>
                </template>
                <template #cell(amount)="data">
                  {{ commas(data.item.amount) }}
                </template>
                <template #cell(payback)="data">
                  {{ commas(data.item.payback) }}
                </template>
                <template #cell(financialyear)="data">
                  {{ data.item.financialyear.name }}
                </template>
                <template #cell(expirydate)="data">
                  <span>{{ data.item.expirydate }}</span> <br>
                </template>
                <template #cell(repaymentplan)="data">
                  {{ commas(data.item.repaymentplan) }} <small class="text-info">/</small> {{
                    data.item.repaymentstructure }}
                </template>
                <template #cell(paid)="data">
                  {{ commas(data.item.paid) }}
                </template>
                <template #cell(fine)="data">
                  <!-- <b class="text-danger" v-if="data.item.daysleft < 1">
                    <span v-if="data.item.repaymentstructure == 'day'">
                      {{ commas(Number(data.item.loan_type.fine) * Math.abs(data.item.daysleft)) }}
                    </span>
                    <span v-else-if="data.item.repaymentstructure == 'week'">
                      {{ commas(Number(data.item.loan_type.fine) * Math.floor(Math.abs(data.item.daysleft) / 7)) }}
                    </span>
                    <span v-else-if="data.item.repaymentstructure == 'month'">
                      {{ commas(Number(data.item.loan_type.fine) * Math.floor(Math.abs(data.item.daysleft) / 30)) }}
                    </span>
                  </b>
                  <b class="text-info" v-else>0</b> -->
                  <span class="text-danger fw-bold">{{ commas(data.item.fine) }}</span>
                </template>
                <template #cell(balance)="data">
                  <span v-if="data.item.balance <= 0 && data.item.daysleft > 1">
                    <small class="bg-info text-white px-1 rounded-1"> <i class="mdi mdi-check-circle"></i> Paid</small>
                  </span>
                  <span v-else>
                    <!-- <span v-if="data.item.repaymentstructure == 'day'">
                      {{ commas(Number(data.item.loan_type.fine) *
                        Math.abs(data.item.daysleft) + Number(data.item.balance)) }}
                    </span>
                    <span v-else-if="data.item.repaymentstructure == 'week'">
                      {{ commas(Number(data.item.loan_type.fine) *
                        Math.floor(Math.abs(data.item.daysleft) / 7) + Number(data.item.balance)) }}
                    </span>
                    <span v-else-if="data.item.repaymentstructure == 'month'">
                      {{ commas(Number(data.item.loan_type.fine) *
                        Math.floor(Math.abs(data.item.daysleft) / 30) + Number(data.item.balance)) }}
                    </span> -->
                    {{ commas(Number(data.item.balance) + Number(data.item.fine)) }}
                    <br>
                    <b-button v-show="userData.permissions['repayaloan'] == 1"
                      @click="payaLoan(data.item.id, data.item.member, data.item.amount, data.item.payback, data.item.balance)"
                      type="button" class="btn-sm" variant="primary" title="Repay loan" v-b-modal.edit><i
                        class="mdi mdi-cash"></i> Pay</b-button>
                  </span>
                </template>
                <template #cell(actions)="data">
                  <b-dropdown size="sm" class="m-0" variant="link">
                    <template #button-content><i class="fas fa-ellipsis-v text-dark"></i></template>
                    <b-dropdown-item v-show="(data.item.amount + data.item.interest + data.item.fine - data.item.paid) <= 0"
                      @click="closeloan(data.item.id, data.item.member.name, data.item.amount)" type="button"
                      variant="info" title="Approve" v-b-modal.edit><i class="mdi mdi-check-circle"></i> Close
                      Loan</b-dropdown-item>
                    <!-- <b-dropdown-item v-show="data.item.balance > 0" @click="reschedule(data.item.id,data.item.member.name,data.item.amount,data.item.payback,data.item.balance)" type="button" variant="dark" title="Approve" v-b-modal.edit><i class="mdi mdi-calendar"></i> Reschedule</b-dropdown-item> -->
                    <b-dropdown-item v-show="(data.item.amount + data.item.interest + data.item.fine - data.item.paid) > 0"
                      @click="writeoff(data.item.id, data.item.member.name, data.item.amount, data.item.payback, data.item.balance)"
                      type="button" variant="danger" title="Approve" v-b-modal.edit><i class="mdi mdi-close-circle"></i>
                      Write
                      Off</b-dropdown-item>
                  </b-dropdown>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <b>Total Loans : {{ commas(totalloan) }}</b>
              </div>
              <div class="col text-center">
                <b>Total Paid : {{ commas(totalpaid) }}</b>
              </div>
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to view Loan Arrears</span></center>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="repay-loan" centered title=" Repay a Loan" title-class="font-14" hide-footer>
      <form @submit.prevent="repayaLoan">
        <div class="form-group">
          <label>Member</label>
          <input type="text" class="form-control text-info" style="background: none;" readonly v-model="membername">
        </div>
        <div class="form-group">
          <label>Payback</label>
          <input type="text" class="form-control text-info" style="background: none;" readonly v-model="payback">
        </div>
        <div class="form-group">
          <label>Amount Paid</label>
          <input type="number" class="form-control text-info" v-model="amount">
        </div>
        <div class="form-group mb-2">
          <label>Mode of Payment</label> <small class="text-danger">*</small>
          <v-select :options="paymentoptions" placeholder="Select an Option" v-model="mode_of_payment" label="name"
            :reduce="mode_of_payment => mode_of_payment.id"></v-select>
        </div>
        <div class="form-group mb-2">
          <label>Reference</label>
          <textarea v-model="refference" rows="2" class="form-control"></textarea>
        </div>
        <div class="form-group mb-2">
          <label>Payment Date</label>
          <input type="date" :max="currentdate" class="form-control text-info" v-model="paymentdate">
        </div>
        <small class="text-danger">{{ saveError }}</small>
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('repay-loan')">Close</b-button>
          <b-button type="submit" :disabled="saveBtn" class="btn ms-1 w-30" variant="primary"><i
              class="fas fa-check-circle"></i> Submit</b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="close-a-loan" size="sm" centered title="Close a Loan Disbursement" title-class="font-18" hide-footer>
      <form @submit.prevent="Close_a_Loan">
        <input v-model="id" type="hidden">
        <center> Are you sure you want to Close {{ membername }}`s loan of : <b>{{ commas(amount) }}</b> {{
          userData.currency }} ? </center>
        <div class="form-group d-flex justify-content-end mt-3">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('close-a-loan')">Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary"><i class="fas fa-check-circle"></i>
            YES</b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="reschedule-a-loan" size="sm" centered title="Reschedule a Loan" title-class="font-18" hide-footer>
      <form @submit.prevent="Reschedule_a_Loan">
        <input v-model="id" type="hidden">
        <center> Are you sure you want to Reschedule {{ membername }}`s loan of : <b>{{ commas(amount) }}</b> {{
          userData.currency }} ? </center>
        <br><label>Date</label>
        <input v-model="rescheduledate" type="date" :min="currentdate" class="form-control" />
        <label>Reason</label>
        <textarea v-model="reschedulereason" rows="2" class="form-control"></textarea>
        <div class="form-group d-flex justify-content-end mt-3">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('reschedule-a-loan')">Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary"><i class="fas fa-check-circle"></i>
            YES</b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="write-off-loan" size="sm" centered title="Write Off a Loan" title-class="font-18" hide-footer>
      <form @submit.prevent="Write_off_Loan">
        <input v-model="id" type="hidden">
        <center> Are you sure you want to Write Off {{ membername }}`s loan of : <b>{{ commas(amount) }}</b> {{
          userData.currency }} ? </center>
        <br><label>Reason</label>
        <textarea v-model="writeoffreason" rows="2" class="form-control"></textarea>
        <label>Date</label>
        <input v-model="writeoffdate" type="date" class="form-control" />
        <div class="form-group d-flex justify-content-end mt-3">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('write-off-loan')">Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary"><i class="fas fa-check-circle"></i>
            YES</b-button>
        </div>
      </form>
    </b-modal>

  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { loanarrearMethods, loanarrearComputed, paymentoptionMethods, paymentoptionComputed } from "@/state/helpers";

export default {
  page: {
    title: "Loan Arrears",
    meta: [{ name: "description", content: appConfig.description, },],
  },
  components: {
    Layout, PageHeader
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Loan Arrears",
      items: [{ text: "Dashboard", to: "/", }, { text: "Loan Arrears", active: true, },],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: 'index', label: '#', visible: true },
        { key: 'id', label: 'ID', visible: false },
        { key: 'member', label: 'Member', visible: true },
        { key: 'loan_type', label: 'Loan Product', visible: true },
        { key: 'amount', label: 'Loan', visible: true },
        { key: 'payback', label: 'Payback', visible: true },
        { key: 'repaymentplan', label: 'Repayment Plan', visible: true },
        { key: 'fine', label: 'Fines', visible: true },
        { key: 'paid', label: 'Paid', visible: true },
        { key: 'balance', label: 'Balance', visible: true },
        { key: 'actions', label: 'Actions', visible: true },
        { key: 'expirydate', label: 'Full Repayment', visible: true },
        { key: 'financialyear', label: 'Financial Year', visible: true },
      ],
      id: '',
      member: '',
      charges: '',
      disbursement_date: new Date().toLocaleDateString('fr-CA'),
      application_date: '',
      membername: '',
      payback: '',
      balance: '',
      rate: '',
      period: '',
      loan_rate: '',
      loan_period: '',
      loantype: '',
      interest: '',
      expirydate: new Date(),
      saveBtn: false,
      saveError: '',
      loan_id: '',
      paymentdate: new Date().toLocaleDateString('fr-CA'),
      amount: '',
      mode_of_payment: '',
      refference: '',
      currentdate: new Date().toLocaleDateString('fr-CA'),
      date_to: new Date().toLocaleDateString('fr-CA'),
      date_from: new Date().toLocaleDateString('fr-CA'),
      rescheduledate: new Date().toLocaleDateString('fr-CA'),
      reschedulereason: "",
      writeoffdate: new Date().toLocaleDateString('fr-CA'),
      writeoffreason: "",
      name_hover: false,
      current_index: 0,
    };
  },
  computed: {
    ...loanarrearComputed,
    ...paymentoptionComputed,
    List() { return this.loanarrears.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.loanarrears.map((d) => ({ ...d })) },
    IsBusy() { let a = false; if (this.loanarrears.length > 0) { a = false; } else { a = true; } return a },
    totalloan() { var total = 0; this.loanarrears.forEach((item) => { var item_total = item.amount; total = Number(total) + Number(item_total); }); return total },
    totalpaid() { var total = 0; this.loanarrears.forEach((item) => { var item_total = item.paid; total = Number(total) + Number(item_total); }); return total },
  },
  async mounted() {
    this.fetchPaymentoptions();
    await this.fetchLoanArrears();
    this.TotalRows = this.loanarrears.length;
    this.isBusy = false;
  },
  methods: {
    ...loanarrearMethods,
    ...paymentoptionMethods,
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },

    payaLoan(id, member, payback) {
      this.loan_id = id;
      this.member = member.member_id;
      this.membername = member.name;
      this.payback = payback;
      this.amount = 0;
      this.$bvModal.show('repay-loan')
    },
    closeloan(id, member, amount) {
      this.id = id;
      this.membername = member;
      this.amount = amount;
      this.$bvModal.show('close-a-loan')
    },
    writeoff(id, member, amount) {
      this.id = id;
      this.membername = member;
      this.amount = amount;
      this.$bvModal.show('write-off-loan')
    },
    reschedule(id, member, amount) {
      this.id = id;
      this.membername = member;
      this.amount = amount;
      this.$bvModal.show('reschedule-a-loan')
    },
    async repayaLoan() {
      this.saveBtn = true;
      this.saveError = "Saving Loan Repayment";
      let formData = new FormData();
      formData.append("member", this.member);
      formData.append("loan", this.loan_id);
      formData.append("amount", this.amount);
      formData.append("mode_of_payment", this.mode_of_payment);
      formData.append("refference", this.refference);
      formData.append("date_of_payment", this.paymentdate);
      let url = "/repayaloan";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchLoanArrears();
          this.member = '';
          this.loan_id = '';
          this.amount = '';
          this.refference = '';
          this.saveBtn = false;
          this.saveError = "";
          this.$bvModal.hide('repay-loan');
        }
      });
    },
    async Close_a_Loan() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/closerunningloans";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchLoanArrears();
          this.$bvModal.hide('close-a-loan');
        }
      });
    },
    async Write_off_Loan() {
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("reason", this.writeoffreason);
      formData.append("date", this.writeoffdate);
      let url = "/writeoffrunningloans";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchLoanArrears();
          this.writeoffreason = "";
          this.$bvModal.hide('write-off-loan');
        }
      });
    },
    async Reschedule_a_Loan() {
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("date", this.rescheduledate);
      formData.append("reason", this.reschedulereason);
      let url = "/reschedulerunningloans";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchLoanArrears();
          this.reschedulereason = "";
          this.$bvModal.hide('reschedule-a-loan');
        }
      });
    },
    FilterData() {
      this.filterLoanArrearss({ datefrom: this.date_from, dateto: this.date_to });
    },
  },
};
</script>